import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppContextProvider from '../contexts/app/AppContextProvider';
import BasketContextProvider from '../contexts/basket/BasketContextProvider';
import CustomerContextProvider from '../contexts/customer/CustomerContextProvider';
import GroupContextProvider from '../contexts/group/GroupContextProvider';
import DeliveryVenueContextProvider from '../contexts/delivery-venue/DeliveryVenueContextProvider';
import OperatorContextProvider from '../contexts/operator/OperatorContextProvider';
import OrderContextProvider from '../contexts/order/OrderContextProvider';
import SiteContextProvider from '../contexts/site/SiteContextProvider';
import ToastContextProvider from '../contexts/toast/ToastContextProvider';
import useOperatorContext from '../contexts/operator/useOperatorContext';
import '../styles/App.css';
import Router from './pages/Routes';
import Theme from './Theme';
import { captureAiReferral, reportAiReferral } from '../services/aiReferral';
import { setOperatorAnalytics, trackPageView } from '../services/analytics';

// Tells Google Analytics who the operator is, and of each page as it is shown (see docs/analytics.md)
const AnalyticsTracker = () => {
	const operatorContext = useOperatorContext();
	const location = useLocation();
	const operator = operatorContext.operator;

	useEffect(() => {
		if (operator) {
			setOperatorAnalytics({ google_analytics: operator.google_analytics, ccy: operator.ccy });
		}
	}, [operator]);

	useEffect(() => {
		// a visit that came from an AI assistant is told to Google Analytics, once (the first page of a visit is the one with the referrer)
		reportAiReferral(captureAiReferral());

		// (a moment later, as the title of the page is only set once it has been drawn)
		const path = location.pathname;
		const timer = setTimeout(() => trackPageView(path), 100);

		return () => clearTimeout(timer);
	}, [location.pathname]);

	return null;
};

const App = () => {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <AppContextProvider>
                    <CustomerContextProvider>
                        <OperatorContextProvider>
                        	<>
                        		<AnalyticsTracker />
                            	<Theme>
                                	<ToastContextProvider>
                                    	<SiteContextProvider>
                                        	<DeliveryVenueContextProvider>
                                            	<GroupContextProvider>
                                                	<BasketContextProvider>
                                                    	<OrderContextProvider>
                                                        	<Router />
                                                    	</OrderContextProvider>
                                                	</BasketContextProvider>
                                            	</GroupContextProvider>
                                        	</DeliveryVenueContextProvider>
                                    	</SiteContextProvider>
                                	</ToastContextProvider>
                            	</Theme>
                            </>
                        </OperatorContextProvider>
                    </CustomerContextProvider>
                </AppContextProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
};

export default App;
